enum TradeInSourceName {
  RightRide = "rightride",
  Kijiji = "kijiji",
  AutoCanadaDealer = "ac-dealer",
  Throttle = "throttle",
}

export default TradeInSourceName;
